import { database } from "../firebase";
import { ref, push, onValue, remove } from "firebase/database";

/**
 * Service pour gérer les covoiturages habituels
 * Stockés dans Firebase sous 'habitualCarpools'
 *
 * Format:
 * habitualCarpools/<id> = { driverName: string, passengerName: string, createdAt: number }
 */

export function listenToHabitualCarpools(callback) {
  try {
    const habitualRef = ref(database, "habitualCarpools");

    const unsubscribe = onValue(
      habitualRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const items = [];
          snapshot.forEach((childSnapshot) => {
            items.push({
              id: childSnapshot.key,
              ...childSnapshot.val(),
            });
          });
          callback(items);
        } else {
          callback([]);
        }
      },
      (error) => {
        console.error("❌ [habitualCarpoolsService] Erreur listener:", error);
        callback([]);
      },
    );

    return unsubscribe;
  } catch (error) {
    console.error("❌ [habitualCarpoolsService] Erreur setup listener:", error);
    return () => {};
  }
}

export async function addHabitualCarpool({
  driverName,
  driverIcon,
  passengerName,
  passengerIcon,
}) {
  try {
    const d = String(driverName || "").trim();
    const p = String(passengerName || "").trim();

    if (!d || !p) {
      throw new Error("Le nom du conducteur et du passager sont requis");
    }

    const habitualRef = ref(database, "habitualCarpools");
    const newRef = await push(habitualRef, {
      driverName: d,
      driverIcon: driverIcon ? String(driverIcon) : null,
      passengerName: p,
      passengerIcon: passengerIcon ? String(passengerIcon) : null,
      createdAt: Date.now(),
    });

    console.log("✅ [habitualCarpoolsService] Habituels ajouté:", newRef.key);
    return { success: true, id: newRef.key };
  } catch (error) {
    console.error("❌ [habitualCarpoolsService] Erreur ajout:", error);
    return { success: false, error: error.message };
  }
}

export async function deleteHabitualCarpool(itemId) {
  try {
    const itemRef = ref(database, `habitualCarpools/${itemId}`);
    await remove(itemRef);
    console.log("✅ [habitualCarpoolsService] Habituels supprimé:", itemId);
    return { success: true };
  } catch (error) {
    console.error("❌ [habitualCarpoolsService] Erreur suppression:", error);
    return { success: false, error: error.message };
  }
}

